import { render, staticRenderFns } from "./compLogList.vue?vue&type=template&id=194f152d"
import script from "./compLogList.vue?vue&type=script&lang=js"
export * from "./compLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports